module.exports = __webpack_public_path__ + "img/tim_f5.236c8557.gif";